import React, { memo } from 'react';
import AddressHeaderContainer from './AddressHeaderContainer';
import RightAddress from './RightAddress';
import { HeaderWrapper, HeaderContainer } from './styled';

const Header = memo(() => {
  return (
    <HeaderWrapper>
      <HeaderContainer>
        <AddressHeaderContainer />
        <RightAddress />
      </HeaderContainer>
    </HeaderWrapper>
  );
});

export default Header;
